// extracted by mini-css-extract-plugin
export var grayCircle = "_df-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_df-1";
export var selectedCircle = "_df-2";
export var shippingOptionImage = "_df-3";
export var shippingOptionWidgetPreview = "_df-4";